/**
 * Noun-agnostic string constants for the template library gallery surface
 * (S3). Same rename-ready pattern as picker/pickerStrings.ts: every new
 * user-facing string on the gallery/cards routes through here so Carl's
 * gated noun flip stays a one-commit change. NO "Recipe" strings until the
 * naming window opens.
 */

export const GALLERY_STRINGS = {
  /** Class headers + fitness-first descriptions (CONSULTS §1: cards/classes
   *  describe their OWN purpose — negative framing is banned copy). */
  classes: {
    compact: {
      header: 'Compact',
      fitness: 'Short-form · best for quick updates',
    },
    standard: {
      header: 'Standard',
      fitness: 'Full-length articles',
    },
  },
  pane: {
    whatYoullGet: "What you'll get",
    /** The variable-output feedforward line (§5): brief, timely, at the
     *  point of action. Appears under the pane's Shape ONLY. */
    honestyCaption:
      'Shape, not content — the writer plans each article fresh from your keyword.',
    useThisTemplate: 'Use This Template',
    /** W3 label of record (name-matches-click ruling): the drawer renders
     *  the full-length shape wireframe — "See full preview" is FORBIDDEN. */
    expandShape: 'Expand shape',
    makeYourOwnCopy: 'Make your own copy',
    edit: 'Edit',
    duplicate: 'Duplicate',
    delete: 'Delete',
    close: 'Close',
    /** Fixed-slot baseline row (CONSULTS §2): identical slot order on every
     *  recipe; absent-by-design = struck/em-dash, NEVER plain grey. */
    slots: {
      toc: 'TOC',
      keyTakeaways: 'Takeaways',
      list: 'List',
      table: 'Table',
      callout: 'Callout',
      image: 'Image',
      faq: 'FAQ',
    },
    groups: {
      lengthTone: 'Length & tone',
      structure: 'Structure',
      components: 'Components',
      links: 'Links',
    },
    aiDecides: 'AI decides',
  },
  specLine: {
    wordsUnit: 'WORDS',
    sectionsUnit: 'SECTIONS',
    /** Footnote for the superscript floor tick (CONSULTS §4: the tooltip is
     *  the footnote; the tick is the sole in-line marking). */
    floorTickNote: 'Raised to the production floor',
  },
  card: {
    use: 'Use',
    useTemplate: 'Use Template',
    /** W3 label of record — same string as the pane slot. */
    expandShape: 'Expand shape',
    customizeCopy: 'Customize Copy',
    delete: 'Delete',
    yours: 'YOURS',
    noDescription: 'No description available',
  },
  editFocus: {
    title: 'Editing',
    settings: 'Template settings',
    liveShape: "What you'll get (live)",
    cancel: 'Cancel',
    save: 'Save',
    /** Signal 4 (CONSULTS §3): the commit moment, signified — tied to the
     *  pending state of each dirty field. */
    commitHint: 'Enter to apply · applies when you leave this field',
    /** Signal 2: minimal preview-stale indicator (dot/tag — never a banner). */
    staleTag: 'pending',
  },
} as const;
